export default "__VITE_ASSET__DIrDARGe__"